import React, { useState } from 'react';
import { IProviderReport } from '../models';
import { Colors, PrimaryButton, SecondaryButton, Text } from 'library';
import { Grid } from '@material-ui/core';
import { format12HourTime, formatShortWeekdayMonthDay } from 'shared/Dates';
import { approveReport } from '../HourReportMethods';
import { consoleLogInDev } from 'shared';

export default function Report({
    report,
    setChangeReport,
    updateHoursReported,
}: {
    report: IProviderReport;
    setChangeReport: (r: IProviderReport) => void;
    updateHoursReported: () => void;
}) {
    const [loading, setLoading] = useState(false);

    function approveAction() {
        setLoading(true);
        approveReport(report.id, { business_approved_date: new Date() })
            .catch(consoleLogInDev)
            .finally(() => {
                updateHoursReported();
                setLoading(false);
            });
    }
    return (
        <Grid
            direction="column"
            container
            item
            justify="space-between"
            style={{
                borderRadius: 18,
                padding: 20,
                margin: 10,
                backgroundColor: Colors.white,
                boxShadow: '0px 3px 6px 0px #00000029',
                gap: 10,
            }}
        >
            <Text bold>{formatShortWeekdayMonthDay(report.start)}:</Text>
            <Grid container item justify="space-between">
                <Text>
                    {format12HourTime(report.start)} - {report.end ? format12HourTime(report.end) : ''}
                </Text>
                <Text>Break: {report.break ? `${report.break} minutes` : 'No Break'}</Text>
                <Text>Total Hours: {report.hours}</Text>
            </Grid>
            <Grid
                container
                item
                direction="row"
                justify="space-between"
                alignContent="center"
                style={{ marginTop: 10 }}
            >
                {report.status === 'Awaiting Business' ? (
                    <>
                        <SecondaryButton
                            disabled={loading}
                            onClick={() => {
                                setChangeReport(report);
                            }}
                            buttonStyle={{ margin: 5, width: 150 }}
                        >
                            Dispute
                        </SecondaryButton>
                        <PrimaryButton
                            disabled={loading}
                            onClick={approveAction}
                            buttonStyle={{ margin: 5, width: 150 }}
                        >
                            Approve
                        </PrimaryButton>
                    </>
                ) : (
                    <>
                        <Text textStyle={{ width: '100%' }}>
                            <Text bold>Status:</Text> {report.status}
                        </Text>
                    </>
                )}
            </Grid>
        </Grid>
    );
}
